'use strict';

var keyMirror = require('keymirror');

module.exports = {
	ActionTypes: keyMirror({
		EQUIPMENT_SEARCH_LOAD_DATA: null,
		EQUIPMENT_SEARCH_LOAD_DATA_SUCCESS: null,
		EQUIPMENT_SEARCH_LOAD_DATA_ERROR: null,
		EQUIPMENT_SEARCH_UPDATE_FILTERS: null,
		EQUIPMENT_SEARCH_SUBMIT_FORM: null,
		EQUIPMENT_SEARCH_CLEAR_FILTERS: null
	})
};